import moment from 'moment'

export function formatDateRange(date1Str: string, date2Str: string): string {
  const date1 = moment(date1Str)
  const date2 = moment(date2Str)

  const start = date1 < date2 ? date1 : date2
  const end = date1 >= date2 ? date1 : date2

  if (start.format('YYYY-MM') === end.format('YYYY-MM')) {
    // Same month and year
    return `${start.format('DD MMMM')} - ${end.format('D YYYY')}`
  } else if (start.format('YYYY') === end.format('YYYY')) {
    // Same year, different month
    return `${start.format('DD MMMM')} - ${end.format('DD MMMM YYYY')}`
  } else {
    // Different month, different year
    return `${start.format('DD MMMM YYYY')} - ${end.format('DD MMMM YYYY')}`
  }
}

export function toDateOnlyString(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

type DateOnlyLike =
  | string
  | {
      year?: number
      month?: number
      day?: number
    }

export function dateOnlyToDate(value?: DateOnlyLike | null): Date | null {
  if (!value) return null

  if (typeof value === 'string') {
    const [year, month, day] = value.split('-').map(Number)
    if (!year || !month || !day) return null

    return new Date(year, month - 1, day)
  }

  if (!value.year || !value.month || !value.day) return null

  return new Date(value.year, value.month - 1, value.day)
}

export function formatDateOnly(value?: DateOnlyLike | null): string | null {
  const date = dateOnlyToDate(value)
  if (!date) return null

  return moment(date).format('DD MMM YYYY')
}
